export enum COMMON_HTTP_METHOD_TYPE {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
}
